import { Component, OnInit, Input, TemplateRef, ViewChild, ElementRef } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.css'],
})
export class ModalConfirmComponent implements OnInit {
  confirm_class: string = 'primary';
  confirm_function: any;
  cancel_function: any;
  modal_header: string | undefined;
  modal_body: string | undefined;
  modal_confirm: string | undefined;
  modal_cancel: string | undefined;
  current_scope: any;

  @ViewChild('modal', { static: true }) modalRef: ElementRef;

  constructor() {}

  ngOnInit() {}

  openModal() {
    jQuery(this.modalRef.nativeElement).modal('show');
  }

  closeModal(action: string | null = null) {
    try {
      if ((jQuery(this.modalRef.nativeElement).data('bs.modal') || {})._isShown) jQuery(this.modalRef.nativeElement).modal('hide');
    } catch (err) {
      console.log(err);
    }
    switch (action) {
      case 'confirm':
        if (this.confirm_function) this.confirm_function(this.current_scope);
        break;
      case 'cancel':
        if (this.cancel_function) this.cancel_function(this.current_scope);
        break;
    }
    this.resetModal();
  }

  resetModal() {
    this.confirm_class = 'primary';
    this.confirm_function = undefined;
    this.cancel_function = undefined;
    this.modal_header = undefined;
    this.modal_body = undefined;
    this.modal_confirm = undefined;
    this.modal_cancel = undefined;
    this.current_scope = undefined;
  }
}
